import React, { memo, useEffect, useState } from 'react';
import s from './DataInput.module.css';
import classNames from 'classnames';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useTranslation } from 'react-i18next';

export const DateInput = memo(
    ({
        date,
        parameterName,
        callback,
        options,
        newCallback,
        isDisabled,
        newCallbackNotSingle,
        placeholder,
        newCallbackNotSingleCancel,
        classes,
    }) => {
        const { t } = useTranslation();
        const [inputValue, setInputValue] = useState(date);

        const locale = {
            format: 'DD.MM.YYYY',
            firstDay: 1,
            daysOfWeek: [
                t('DateInput.locale.format.daysOfWeek.sunday'),
                t('DateInput.locale.format.daysOfWeek.monday'),
                t('DateInput.locale.format.daysOfWeek.tuesday'),
                t('DateInput.locale.format.daysOfWeek.wednesday'),
                t('DateInput.locale.format.daysOfWeek.thursday'),
                t('DateInput.locale.format.daysOfWeek.friday'),
                t('DateInput.locale.format.daysOfWeek.saturday'),
            ],
            monthNames: [
                t('DateInput.locale.format.monthNames.january'),
                t('DateInput.locale.format.monthNames.february'),
                t('DateInput.locale.format.monthNames.march'),
                t('DateInput.locale.format.monthNames.april'),
                t('DateInput.locale.format.monthNames.may'),
                t('DateInput.locale.format.monthNames.june'),
                t('DateInput.locale.format.monthNames.july'),
                t('DateInput.locale.format.monthNames.august'),
                t('DateInput.locale.format.monthNames.september'),
                t('DateInput.locale.format.monthNames.october'),
                t('DateInput.locale.format.monthNames.november'),
                t('DateInput.locale.format.monthNames.december'),
            ],
            cancelLabel: t('button.clear.text'),
            applyLabel: t('button.save.text'),
        };

        const initSetting = Object.assign(options, { locale });

        const inputProps = {
            defaultValue: '',
        };

        if (date) {
            // @ts-ignore
            inputProps.defaultValue = inputValue;
        }

        const handleCancel = (event, picker) => {
            if (date === '') {
                return;
            }
            picker.element.val('');
            if (callback) {
                callback();
            }
            if (newCallbackNotSingleCancel) {
                newCallbackNotSingleCancel();
            }
        };

        const handleApply = (event, picker) => {
            picker.element.val(picker.startDate.format('DD.MM.YYYY'));
            setInputValue(picker.startDate.format('DD.MM.YYYY'));
            if (newCallback) {
                newCallback(picker.startDate.format('YYYY-MM-DD'));
            }
            if (newCallbackNotSingle) {
                picker.element.val(picker.startDate.format('DD.MM.YYYY'));

                newCallbackNotSingle({
                    start: picker.startDate.format(),
                    end: picker.endDate.format(),
                });
            }
        };

        useEffect(() => {
            setInputValue(date);
        }, [date]);

        return (
            <div className={classNames(s.wrapperInput)}>
                <div className={s.calendar}>
                    {isDisabled ? (
                        <div className={classNames(s.svgWrapper)}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M16.25 5H3.25V17H16.25V5Z" stroke="#757575" />
                                <path d="M7.25 3H5.25V7H7.25V3Z" stroke="#757575" />
                                <path
                                    d="M16.5 8.75H3V9.25H16.5V8.75Z"
                                    stroke="#757575"
                                    strokeWidth="0.5"
                                />
                                <path d="M14.25 3H12.25V7H14.25V3Z" stroke="#757575" />
                            </svg>
                        </div>
                    ) : (
                        <DateRangePicker
                            initialSettings={initSetting}
                            onApply={handleApply}
                            onCancel={handleCancel}
                            {...inputProps}
                        >
                            {!!date ? (
                                <input
                                    placeholder={placeholder ? placeholder : ''}
                                    className={classNames(s.input, [classes])}
                                    data-id={parameterName}
                                    type="text"
                                    disabled={isDisabled}
                                />
                            ) : (
                                <div className={classNames(s.svgWrapper)}>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M16.25 5H3.25V17H16.25V5Z" stroke="#757575" />
                                        <path d="M7.25 3H5.25V7H7.25V3Z" stroke="#757575" />
                                        <path
                                            d="M16.5 8.75H3V9.25H16.5V8.75Z"
                                            stroke="#757575"
                                            strokeWidth="0.5"
                                        />
                                        <path d="M14.25 3H12.25V7H14.25V3Z" stroke="#757575" />
                                    </svg>
                                </div>
                            )}
                        </DateRangePicker>
                    )}
                </div>
            </div>
        );
    }
);
